/**
 * @desc 根据spu编号集合查询spu列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSpuListResponseRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/spu/getSpuInfoListBySpuNos`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
